/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";

import Stack from "@mui/material/Stack";
import {
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import Div from "@jumbo/shared/Div";
import Loader from "@jumbo/components/Loader";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import { useDispatch, useSelector } from "react-redux";
import { userType } from "app/helpers/userType";
import { useNavigate, useParams } from "react-router-dom";
import {
  getProductInwardList,
  deleteProductInward,
} from "app/redux/slice/productSlice";
import { LoadingButton } from "@mui/lab";
import { useSnackbar } from "notistack";
import { Delete, Edit } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { PRODUCTS_INWARD_ADD } from "app/routes/constant";
import moment from "moment";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";
import DialogDefault from "@jumbo/components/JumboDialog/components/DialogDefault";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";
import {
  getProductList,
  updateProductInward,
} from "app/redux/slice/productSlice";
import { getVariantList } from "app/redux/slice/variantSlice";

const GODOWN_OPTIONS = [
  { id: 1, name: "Vipulbhai" },
  { id: 2, name: "Dharmendra" },
  { id: 3, name: "Fenil" },
];

const ProductInward = () => {
  const {
    isOpen: isEditOpen,
    onClose: closeEdit,
    stageAction,
    actionProps: editActionProps,
  } = useDisclosure();
  const dispatch = useDispatch();
  const { isMA } = userType();
  let { productId } = useParams();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();
  const productInwardData = useSelector((state) => state?.product);
  const productData = useSelector((state) => state?.product);
  const variantData = useSelector((state) => state?.variant);

  const [searchText, setSearchText] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "product-inward" });

  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission")),
  );

  const [permission, setPermission] = useState({
    createPermission: false,
    updatePermission: false,
  });
  const getPermission = () => {
    if (isMA) {
      setPermission({
        createPermission: true,
        updatePermission: true,
      });
    } else {
      let permissionValue = {
        createPermission: false,
        updatePermission: false,
      };

      permissionData?.length &&
        permissionData.forEach(function (num) {
          if (num?.name === "create-product") {
            permissionValue.createPermission = true;
          }
          if (num?.name === "update-product") {
            permissionValue.updatePermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  const columns = [
    {
      id: "createdAt",
      label: "Date",
      sort: true,
      render: (row) => moment(row?.createdAt).format("DD-MM-YYYY"),
    },
    {
      id: "productId",
      label: "Product Name",
      render: (elm) => elm?.productId?.name,
    },
    {
      id: "variantId",
      label: "Variant",
      render: (elm) => elm?.variantId?.name,
    },
    { id: "quantity", label: "Qty", sort: true },
    {
      id: "performBy",
      label: "Perform By",
      render: (elm) => elm?.performBy?.name,
    },
    { id: "millNo", label: "Mill No", sort: true },
    { id: "gp", label: "GP", sort: true },
    { id: "lotNo", label: "Lot No", sort: true },
    {
      id: "processId",
      label: "Process No",
      render: (elm) => elm?.processId?.processNo || "",
    },
    {
      id: "godownType",
      label: "Godown Type",
      sort: true,
    },
    {
      id: "actions",
      label: "Actions",
      render: (row) => (
        <div>
          <IconButton
            disabled={!permission.updatePermission}
            onClick={() => {
              stageAction(row);
            }}
          >
            <Edit />
          </IconButton>
          <IconButton
            onClick={() => {
              deleteStageAction(row);
            }}
            color="error"
          >
            <Delete />
          </IconButton>
        </div>
      ),
      align: "right",
    },
  ];

  const getData = () => {
    localStorage.setItem("product-inward-search", searchText.trim());
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
      productId,
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getProductInwardList(value));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };
  const DeleteProduct = () => {
    closeDelete();
    dispatch(deleteProductInward(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };
  useEffect(() => {
    getPermission();
    // load product/variant lists for edit dialog
    dispatch(getProductList({ sort: 1, field: "name" }));
    dispatch(getVariantList({ field: "name", sort: 1 }));
  }, []);

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  return (
    <>
      {productInwardData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={10}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Product Inward List
                </Typography>
                {permission.createPermission && (
                  <LoadingButton
                    onClick={() => {
                      navigate(PRODUCTS_INWARD_ADD);
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Product Inward
                  </LoadingButton>
                )}
              </Stack>
              <Table
                columns={columns}
                rows={productInwardData?.listInward}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={productInwardData?.totalInward}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
          <DialogDefault
            open={isEditOpen}
            onClose={closeEdit}
            content={
              <Formik
                initialValues={{
                  productId: editActionProps?.productId ?? null,
                  variantId: editActionProps?.variantId ?? null,
                  godownType: editActionProps?.godownType
                    ? GODOWN_OPTIONS.find(
                        (g) => g.name === editActionProps.godownType,
                      )
                    : null,
                  quantity: editActionProps?.quantity ?? 0,
                  millNo: editActionProps?.millNo ?? "",
                  gp: editActionProps?.gp ?? "",
                  lotNo: editActionProps?.lotNo ?? "",
                }}
                enableReinitialize
                validationSchema={Yup.object({
                  // godownType: Yup.object()
                  //   .nullable()
                  //   .required("The godown type is required"),
                  quantity: Yup.number()
                    .nullable()
                    .typeError("Quantity must be a number")
                    .required("Please enter quantity")
                    .min(1, "Quantity cannot be 0 or negative")
                    .integer("Quantity must be a whole number")
                    .test("max-process-qty", function (value) {
                      const { variantId } = this.parent;
                      if (!variantId || !value) return true;
                      if (
                        value <=
                        (editActionProps?.processId?.pendingQty +
                          editActionProps?.quantity || 0)
                      ) {
                        return true;
                      }
                      return this.createError({
                        message: `Quantity cannot exceed ${
                          editActionProps?.processId?.pendingQty +
                            editActionProps?.quantity || 0
                        }`,
                      });
                    }),
                  lotNo: Yup.string()
                    .trim()
                    .required("Please enter lot number")
                    .max(50, "Lot number cannot exceed 50 characters"),
                })}
                onSubmit={async (values, { setSubmitting }) => {
                  setSubmitting(true);
                  const updateData = {
                    godownType: values.godownType?.name,
                    quantity: values.quantity,
                    millNo: values.millNo,
                    gp: values.gp,
                    lotNo: values.lotNo.trim(),
                  };
                  const response = await dispatch(
                    updateProductInward({
                      id: editActionProps?._id,
                      data: updateData,
                    }),
                  ).unwrap();
                  if (response.status === 200) {
                    enqueueSnackbar(response.data?.responseMessage, {
                      variant: "success",
                    });
                    getData();
                    closeEdit();
                    setSubmitting(false);
                  } else {
                    enqueueSnackbar(response.data?.responseMessage, {
                      variant: "error",
                    });
                    setSubmitting(false);
                  }
                }}
              >
                {({ values, setFieldValue, isSubmitting, errors }) => (
                  <Form>
                    <div>
                      <Grid container spacing={3} mb={3}>
                        <Grid item xs={12} sm={6}>
                          <JumboAutoComplete
                            options={productData.list ?? []}
                            label="Product"
                            size="large"
                            getOptionLabel={(option) => option?.name}
                            name={`productId`}
                            value={values?.productId}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <JumboAutoComplete
                            options={
                              values?.productId
                                ? variantData?.list?.filter(
                                    (list) =>
                                      list?.product?._id ===
                                      values?.productId?._id,
                                  ) || []
                                : []
                            }
                            label="Variant"
                            size="large"
                            getOptionLabel={(option) => option?.name}
                            name={`variantId`}
                            value={values?.variantId}
                            disabled
                          />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <JumboAutoComplete
                            options={GODOWN_OPTIONS}
                            label="Godown Type"
                            size="large"
                            getOptionLabel={(option) => option?.name}
                            name={`godownType`}
                            value={values?.godownType}
                            onChange={(evt, value) =>
                              setFieldValue(`godownType`, value)
                            }
                            helperText={errors?.godownType ?? ""}
                          />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            name={`quantity`}
                            type="text"
                            label="Qty*"
                            onChange={(e) =>
                              setFieldValue(`quantity`, +e.target.value)
                            }
                            value={values?.quantity}
                            error={errors?.quantity ? true : false}
                            helperText={errors?.quantity ?? ""}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            name={`millNo`}
                            label="Mill No"
                            onChange={(e) =>
                              setFieldValue(`millNo`, e.target.value)
                            }
                            value={values?.millNo}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            name={`gp`}
                            label="GP"
                            onChange={(e) =>
                              setFieldValue(`gp`, e.target.value)
                            }
                            value={values?.gp}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            name={`lotNo`}
                            label="Lot No*"
                            onChange={(e) =>
                              setFieldValue(`lotNo`, e.target.value)
                            }
                            value={values?.lotNo}
                            error={errors?.lotNo ? true : false}
                            helperText={errors?.lotNo ?? ""}
                            disabled
                          />
                        </Grid>
                      </Grid>
                    </div>

                    <Stack
                      spacing={{ xs: 1, sm: 2 }}
                      direction="row"
                      justifyContent="flex-end"
                      alignItems="flex-end"
                      sx={{ width: "100%" }}
                    >
                      <LoadingButton
                        variant="outlined"
                        color="secondary"
                        size="large"
                        onClick={() => {
                          closeEdit();
                        }}
                      >
                        Cancel
                      </LoadingButton>
                      <LoadingButton
                        type="submit"
                        variant="contained"
                        size="large"
                        loading={isSubmitting}
                      >
                        Update
                      </LoadingButton>
                    </Stack>
                  </Form>
                )}
              </Formik>
            }
            title={
              editActionProps?._id
                ? "Update Product Inward"
                : "Update Product Inward"
            }
            fullWidth={true}
            maxWidth={"md"}
            actions={<></>}
          />

          <DialogConfirm
            isOpen={isDelete}
            onClose={closeDelete}
            title="Are you sure you want to delete the product inward?"
            onConfirm={DeleteProduct}
            btnLabels={{ cancel: "Cancel", confirm: "Delete" }}
          />
        </>
      )}
    </>
  );
};

export default ProductInward;
